/**
 * Client-side signup country signals.
 * Server-side resolution and reporting live in functions/countryAttribution.js.
 */

export function buildSignupCountrySignals() {
  const locale = typeof navigator !== "undefined"
    ? (navigator.language || navigator.userLanguage || "")
    : "";
  const timezone = typeof Intl !== "undefined"
    ? Intl.DateTimeFormat().resolvedOptions().timeZone || ""
    : "";

  return {
    browserLocale: locale,
    browserTimezone: timezone,
  };
}
